import { Inventory } from "src/utils/interfaces/interfaces";
import { FaLock, FaLockOpen } from "react-icons/fa6";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { BatteryProgress } from "./BatteryProgress";

export interface IShipperOrdersProps {
  inventory: Inventory;
  onUnlock: Function;
}

export function InventoryCard({
  inventory,
  onUnlock,
}: {
  inventory: Inventory;
  onUnlock?: () => void;
}) {
  const { t } = useTranslation();
  const [chargingProgress, setChargingProgress] = useState(0);

  useEffect(() => {
    let interval: NodeJS.Timeout;
    if (inventory?.batteryLevel === 255) {
      interval = setInterval(() => {
        setChargingProgress((prevProgress) =>
          prevProgress >= 100 ? 0 : prevProgress + 10
        );
      }, 400);
    }
    return () => {
      clearInterval(interval);
    };
  }, [inventory?.batteryLevel]);

  const locationText = inventory.location
    ? inventory.location.length > 42
      ? `${inventory.location.substring(0, 42)}...`
      : inventory.location
    : "N/A";

  return (
    <div
      className="rounded-2xl border p-4 transition-all duration-200"
      style={{
        backgroundColor: "var(--bg-surface)",
        borderColor: "var(--border-light)",
        boxShadow: "var(--shadow-card)",
      }}
    >
      <div className="grid grid-cols-12 gap-3">
        <div className="col-span-2">
          <div
            className="flex h-14 w-14 items-center justify-center rounded-2xl"
            style={{ backgroundColor: "var(--bg-surface-2)" }}
          >
            <FaLock className="text-xl" style={{ color: "var(--color-primary)" }} />
          </div>
        </div>
        <div className="col-span-10">
          <div className="grid grid-cols-2 gap-2">
            <div>
              <p className="mb-1 text-xs" style={{ color: "var(--text-muted)" }}>
                IMEI
              </p>
              <p className="text-xl font-semibold">{inventory.imei || "N/A"}</p>
            </div>
            <div>
              <p className="mb-1 text-xs" style={{ color: "var(--text-muted)" }}>
                Battery Level
              </p>
              <div className="relative flex items-center mt-1">
                {inventory?.batteryLevel !== undefined &&
                  inventory?.batteryLevel !== null ? (
                  inventory.batteryLevel === 255 ? (
                    <BatteryProgress level={undefined} value={chargingProgress} text="Charging" />
                  ) : (
                    <>
                      <BatteryProgress level={inventory.batteryLevel} value={inventory.batteryLevel} />
                      <p className="ml-2 text-sm">{inventory.batteryLevel}%</p>
                    </>
                  )
                ) : (
                  <p className="text-base">N/A</p>
                )}
              </div>
            </div>
          </div>
          {/* <div className="mt-3">
            <p className="mb-1 text-xs" style={{ color: "var(--text-muted)" }}>
              Location
            </p>
            <p
              className="text-base"
              data-tooltip-id="tooltip"
              data-tooltip-content={inventory.location}
            >
              {locationText}
            </p>
          </div> */}
          <div className="mt-3 grid grid-cols-2 gap-2">
            <div>
              <p className="mb-1 text-xs" style={{ color: "var(--text-muted)" }}>
                Latitude
              </p>
              <p className="text-base">{inventory.latitude || "N/A"}</p>
            </div>
            <div>
              <p className="mb-1 text-xs" style={{ color: "var(--text-muted)" }}>
                Longitude
              </p>
              <p className="text-base">{inventory.longitude || "N/A"}</p>
            </div>
          </div>
        </div>
      </div>
      <div
        className="mt-4 flex items-center justify-end border-t pt-3"
        style={{ borderColor: "var(--border-light)" }}
      >
        <button
          type="button"
          className="flex items-center gap-2 rounded-lg px-4 py-2 text-sm font-semibold transition-colors duration-200"
          style={{
            backgroundColor: "var(--color-primary)",
            color: "var(--text-invert)",
          }}
          onClick={onUnlock}
        >
          <FaLockOpen className="text-sm" />
          {t("button.unlock")}
        </button>
      </div>
    </div>
  );
}
